import { Bounce, toast } from "react-toastify";
import api from "../api";

const TrainerCurriculum = ({ curriculum, cvUploaded, codiceFiscale }) => {
  const cf = curriculum?.codiceFiscale ?? codiceFiscale;

  const handleDownload = async () => {
    if (!cf) return;
    try {
      const response = await api.get("/curriculum/download", {
        params: { codiceFiscale: cf },
        responseType: "blob",
      });

      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      const contentDisposition = response.headers["content-disposition"];
      let filename = curriculum?.filename || "curriculum.pdf";
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?(.+?)"?$/);
        if (match) filename = match[1];
      }

      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      toast.error("Errore durante il download del curriculum", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    }
  };

  if (!cvUploaded) {
    return <div className="no-cv">Questo docente non ha caricato il CV.</div>;
  }

  return (
    <div className="info-card curriculum">
      <div className="card-header curriculum"></div>
      <div className="card-content">
        <div className="cv-section">
          <div className="cv-status">
            <div className="cv-indicator">
              <i
                className={`fa-solid ${
                  cvUploaded ? "fa-check-circle" : "fa-times-circle"
                }`}
              ></i>
              <span>CV {cvUploaded ? "Caricato" : "Non Caricato"}</span>
            </div>
            {cvUploaded && (
              <button className="download-cv-btn" onClick={handleDownload}>
                <i className="fa-solid fa-download"></i>
                Scarica CV
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrainerCurriculum;
